const EXPENSE_STATUSES = [
  'pending',
  'approved',
  'rejected'
];

export default EXPENSE_STATUSES;
